import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { initializeApollo, addApolloState } from '@apollo-client';
import Blog, { GET_POST } from '@_pages/blog/slug';
import { filterSinglePostByCategory } from '@helpers/categoryFilters';

export async function getServerSideProps({ query, locale, res }) {
  const { slug, ...queryParams } = query;

  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: GET_POST,
    variables: {
      slug,
    },
  });

  if (!data.learnArticle && !data.post) {
    return {
      notFound: true,
    };
  }

  if (!filterSinglePostByCategory(data.learnArticle || data.post, 'Supply')) {
    res.writeHead(308, {
      Location: `/blog/${slug}${
        Object.keys(queryParams).length > 0 ? `?${new URLSearchParams(queryParams)}` : ''
      }`,
    });
    res.end();
    return { props: {} };
  }

  return addApolloState(apolloClient, {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  });
}

export default Blog;
